import { useState, useEffect, useMemo } from "react";
import { Select } from "antd";
import { useNavigate } from 'react-router-dom';
import dayjs from "dayjs";
import { isMobile } from "@/extensions/design";
import PaymentsList from "./payments-list"
import Tickets from "./tickets"
import PaymentsFilter from "./payments-filter";

const Payments = ({page}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const getItem = (title, link) => <a className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")} href={"/" + link}>{title}</a>;

  const pages = [
    { title: "Платежи", link: "payments" },
    { title: "Чеки", link: "tickets"}
  ];

  // Инициализация фильтров из localStorage при монтировании
  useEffect(() => {
    const key = page === 'tickets' ? 'ticketsFilter' : 'paymentsFilter';
    const savedFilter = localStorage.getItem(key);
    if (savedFilter) {
      try {
        setFilter(JSON.parse(savedFilter));
      } catch (e) {
        console.warn('Ошибка при загрузке фильтра из localStorage:', e);
      }
    }
  }, [page]);

  const normalizeExternalFilter = (extFilter) => {
    if (!extFilter) return null;
    const normalized = { ...extFilter };
    if (normalized.dateBeg && typeof normalized.dateBeg === 'string') {
      normalized.dateBeg = dayjs(normalized.dateBeg);
    }
    if (normalized.dateEnd && typeof normalized.dateEnd === 'string') {
      normalized.dateEnd = dayjs(normalized.dateEnd);
    }
    return normalized;
  };

  const externalFilter = useMemo(() => {
    const normalized = normalizeExternalFilter(filter);
    if (!normalized) return null;
    // На мобильной вёсртке, дочерние компоненты сами управляют фильтрами по датам, т.к. они не входят в модальное окно с доп.фильтрами.
    // Поэтому отправялем только фильтры без дат в externalFilter.
    const { dateBeg, dateEnd, ...rest } = normalized;
    return Object.keys(rest).length > 0 ? rest : null;
  }, [filter]);

  const getPage = () => {
    switch (page) {
      case "payments": return <PaymentsList externalFilter={externalFilter}/>;
      case "tickets": return <Tickets externalFilter={externalFilter}/>;
      default: return null;
    }
  }
  
  const handlePageChange = (newPage) => {
    navigate(`/${newPage}`);
  };

  return !isMobile ? <div className="col-one-main sport-form-content">
    <div className="col-one-title">
      {getItem("Платежи", "payments")}
      {getItem("Чеки", "tickets")}
    </div>
    <div className="col-one-col">{getPage()}</div>
  </div> : (
  <div className="sport-form-content">
    <div className="col-one-main">
      <div className="col-one-col">
        
        {/* <div className='selector-filer-section'>
          <Select value={page} onChange={handlePageChange} style={{width: "100%"}}>
            {pages.map(p => (
              <Select.Option key={p.link} value={p.link}>
                {p.title}
              </Select.Option>
            ))}
          </Select>
          <img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)}/>
          {showFilter && <PaymentsFilter items={items} value={filter} activePage={page} onClose={(filters) => { setShowFilter(false); if (filters) setFilter(filters); }}/>}
        </div> */}


        <div className="col-one-title-upper-menu">
          <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Оплаты</div>
          <div className="rounded-search-field" style={{padding: "0px", height: "35px"}}>
            <Select value={page} onChange={handlePageChange} style={{ paddingLeft: "16px", borderRadius:"100px", width: "100%", minHeight: "35px" }} className="rounded-search-field custom-select-field" >
              {pages.map(p => (
                <Select.Option key={p.link} value={p.link}>
                  {p.title}
                </Select.Option>
              ))}
            </Select>
            {/* <Input placeholder="Поиск" value={searchText} onChange={(e) => onSearchChange(e.target.value)} allowClear className="search-str" style={{ paddingLeft: "16px", borderRadius:"100px", width: "100%", minHeight: "35px" }}/> */}
          </div>
          <div className="rounded-filter-button" onClick={() => setShowFilter(true)}>
            <img src="/images/filter.svg" className="mobile-top-img" alt="filter" style={{ width: "20px", height: "20px" }} />
          </div>
        </div>
        {showFilter && <PaymentsFilter items={items} value={filter} activePage={page} onClose={(filters) => { setShowFilter(false); if (filters) { setFilter(filters); try { const key = page === 'tickets' ? 'ticketsFilter' : 'paymentsFilter'; localStorage.setItem(key, JSON.stringify(filters)); } catch (e) { console.warn('Ошибка при сохранении фильтра в localStorage:', e); } } }}/>}
        {getPage()}
      </div>
    </div>
  </div>
  )
}

export default Payments;